import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import StickerApi from "api/stickerApi";
import { formatQueryParams } from "helpers/format";

export const getPackageStickers = createAsyncThunk("Stickers", async (params: any = {}) => {
  try {
    const response = await StickerApi.packageStickers(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const getPackageSticker =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await StickerApi.getPackageSticker(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postPackageSticker = async (data: any = {}) => {
  try{
    const response = await StickerApi.postPackageSticker(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putPackageSticker = async (id: string | number , data: any = {}) => {
  try{
    const response = await StickerApi.putPackageSticker(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const getStickers =  async(params: any = {}) => {
  try{
    const response = await StickerApi.getStickers(params)
    return response;
  }catch (error) {
    return error;
  }
};

export const getSticker =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await StickerApi.getSticker(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postSticker = async (data: any = {}) => {
  try{
    const response = await StickerApi.postSticker(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putSticker = async (id: string | number , data: any = {}) => {
  try{
    const response = await StickerApi.putSticker(id, data);
    return response;
  }catch (error) {
    return error;
  }
};